<!-- Usage   -->
<!--
<sa-input-text #Group [(text)]="Idea.Group" [title]="'Group'" [required]="'text'"></sa-input-text>
-->
<div class="sa-form-group"  style="margin-bottom:10px">
  <label class="sa-form-label">
    {{title}}
    <span *ngIf="required != 'none'" style="color:red"> *</span>
  </label>
  <textarea class="form-control sa-formfield-input" [rows]="rows" [ngModel]="text" (ngModelChange)="change($event)" [ngClass]="text ? 'hasValue' : 'noValue'"></textarea>
  <!--<label class="sa-formfield-label">{{title}} <span *ngIf="required != 'none'" style="color:red"> *</span></label>-->
</div>
